import { cn } from '@/shared/lib/cn';

export interface CountryFlagProps {
  /** Dwuliterowy kod kraju wg ISO 3166-1 alpha-2, np. „PL”. */
  code: string;
  className?: string;
}

/**
 * Flaga panstwa przy nazwisku zawodnika.
 *
 * Uzywamy znakow Unicode (Regional Indicator Symbols) zamiast plikow graficznych:
 * zero zadan sieciowych, ostrosc na kazdym powiekszeniu i pelne wsparcie dla
 * wszystkich krajow. Windows nie rysuje kolorowych flag emoji — wtedy widoczny
 * jest czytelny kod literowy, co tez jest poprawnym wynikiem.
 */
export function CountryFlag({ code, className }: CountryFlagProps) {
  const normalized = code.trim().toUpperCase();

  const isValid = /^[A-Z]{2}$/.test(normalized);
  const flag = isValid
    ? String.fromCodePoint(
        ...[...normalized].map((letter) => 0x1f1e6 + (letter.codePointAt(0) ?? 0) - 65),
      )
    : normalized;

  return (
    <span
      title={normalized}
      aria-label={`Kraj: ${normalized}`}
      role="img"
      className={cn(
        'text-fg-muted shrink-0 text-[0.6875rem] leading-none font-semibold',
        className,
      )}
    >
      {flag}
    </span>
  );
}
